<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also By Alex Walters</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">DI  McKay Series</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Candle &amp; Roses ( Book 1)</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Death Parts Us ( Book 2)</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Expiry Date ( Book 4)</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-alex-walters.vue?ade2edb6